import { Box, Stack, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { H5, Small } from '../../components/Typography';
import AppAvatar from '../../components/avatars/AppAvatar';
import FlexBox from '../../components/flexbox/FlexBox';
import FlexRowAlign from '../../components/flexbox/FlexRowAlign';

const data = [
  {
    id: 1,
    rank: 1,
    name: '홍길동',
    likes: 567,
    path: '/naver/callmetellme/mypage',
    avatar: '/static/avatar-photo/avatar-1.png',
  },
  {
    id: 2,
    rank: 2,
    name: '미어캣',
    likes: 331,
    path: '/naver/callmetellme/mypage',
    avatar: '/static/avatar-photo/avatar-2.png',
  },
  {
    id: 3,
    rank: 3,
    name: '김가루뿌링클',
    likes: 86,
    path: '/naver/callmetellme/mypage',
    avatar: '/static/avatar-photo/avatar-3.png',
  },
  {
    id: 4,
    rank: 4,
    name: '딸기쥬스',
    likes: 50,
    path: '/naver/callmetellme/mypage',
    avatar: '/static/avatar-photo/avatar-4.png',
  },
  {
    id: 5,
    rank: 5,
    name: '라이언',
    likes: 41,
    path: '/naver/callmetellme/mypage',
    avatar: '/static/avatar-photo/avatar-2.png',
  },
];

const KnowledgeHelper = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <Box
      sx={{
        backgroundColor: '#ffffff',
        borderRadius: '24px',
        padding: '20px',
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
        border: '1px solid #f0f0f0',
      }}
    >
      <FlexBox
        sx={{
          alignItems: 'center',
          paddingBottom: '16px',
        }}
      >
        <img
          src={'/static/icons/feather.svg'}
          alt="money"
          style={{ width: '24px', height: '24px', marginRight: '8px' }}
        />
        <H5>지식 헬퍼</H5>
      </FlexBox>

      {/* Stats list */}
      <Stack spacing={1}>
        {data.map((item, index) => (
          <Box
            key={index}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              cursor: 'pointer',
            }}
            onClick={() => navigate(item.path || '')}
          >
            <FlexRowAlign>
              <AppAvatar
                src={item.avatar}
                alt={item.name}
                style={{
                  width: '30px',
                  height: '30px',
                  marginRight: '8px',
                  backgroundColor: theme.palette.primary.grey700,
                }}
              />
              <Small
                sx={{
                  fontSize: '16px',
                  color: '#333333',
                  fontWeight: 500,
                  flex: 1,
                  marginRight: '12px',
                }}
              >
                {item.name}
              </Small>
            </FlexRowAlign>
          </Box>
        ))}
      </Stack>
    </Box>
  );
};

export default KnowledgeHelper;
